import { styled, View } from "@tamagui/core";
const XStack = styled(View, {
    flexDirection: "row",
    name: "XStack"
  }),
  YStack = styled(View, {
    flexDirection: "column",
    name: "YStack"
  });
export { XStack, YStack };